/**
 * Inventory permission keys used by the UI (catalog `inv.*` / `rpt.*`; legacy menus 29–38, 50, 144, 208, 524, 660).
 * The API checks the same keys; create, approve and post are separate (G3).
 */
export const invPermissions = {
  openingStockView: "inv.opening_stock.view",
  goodsIssueView: "inv.goods_issue.view",
  goodsReceiptView: "inv.goods_receipt.view",
  adjustmentView: "inv.inventory_adjustment.view",
  adjustmentImport: "inv.inventory_adjustment.import",
  transferView: "inv.transfer_warehouse.view",
  acceptanceView: "inv.transfer_warehouse_acceptance.view",
  acceptanceReceive: "inv.transfer_warehouse_acceptance.receive",
  acceptanceReject: "inv.transfer_warehouse_acceptance.reject",
  stockTypeChangeView: "inv.stock_type_change.view",
  revaluationView: "inv.revaluation.view",
  landedCostView: "inv.landed_cost.view",
  landedCostCreate: "inv.landed_cost.create",
  landedCostUpdate: "inv.landed_cost.update",
  landedCostDelete: "inv.landed_cost.delete",
  landedCostPost: "inv.landed_cost.post",
  landedCostReverse: "inv.landed_cost.reverse",
  countView: "inv.count_inventory.view",
  countCreate: "inv.count_inventory.create",
  countUpdate: "inv.count_inventory.update",
  countDelete: "inv.count_inventory.delete",
  countApprove: "inv.count_inventory.approve",
  countPost: "inv.count_inventory.post",
  countReverse: "inv.count_inventory.reverse",
  countPrint: "inv.count_inventory.print",
  reorderView: "inv.reorder_point.view",
  reorderCreate: "inv.reorder_point.create",
  reorderUpdate: "inv.reorder_point.update",
  reorderDelete: "inv.reorder_point.delete",
  reorderConvert: "inv.reorder_point.convert",
  reasonView: "inv.reason_code.view",
  reasonCreate: "inv.reason_code.create",
  reasonUpdate: "inv.reason_code.update",
  reasonDelete: "inv.reason_code.delete",
  accountSettingsView: "inv.account_settings.view",
  accountSettingsUpdate: "inv.account_settings.update",
  costingView: "inv.costing.view",
  costingRecalculate: "inv.costing.recalculate",
  costingPeriodicClose: "inv.costing.periodic_close",
  stockCardView: "rpt.stock_card.view",
  stockCardPrint: "rpt.stock_card.print",
  stockBalanceView: "rpt.stock_balance.view",
  stockBalancePrint: "rpt.stock_balance.print",
  valuationView: "rpt.ending_inventory_balance.view",
  valuationPrint: "rpt.ending_inventory_balance.print",
  batchAgeingView: "rpt.stock_batch_no_balance.view",
  batchAgeingPrint: "rpt.stock_batch_no_balance.print",
  movementsView: "rpt.stock_movement_history.view",
  movementsPrint: "rpt.stock_movement_history.print",
  serialTraceView: "rpt.serial_trace.view",
  serialTracePrint: "rpt.serial_trace.print",
  slowMovingView: "rpt.slow_moving_items.view",
  slowMovingPrint: "rpt.slow_moving_items.print",
  reconciliationView: "rpt.stock_gl_reconciliation.view",
  reconciliationPrint: "rpt.stock_gl_reconciliation.print",
} as const;

/** Plan module of Inventory (tenant entitlement). */
export const inventoryModule = "inventory";
